import { render, staticRenderFns } from "./paymentcontent.vue?vue&type=template&id=3c1addc4"
import script from "./paymentcontent.vue?vue&type=script&lang=js"
export * from "./paymentcontent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports